import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getInsuranceRiskTypesV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useInsuranceRiskTypesQuery = () => {
	return useQuery({
		queryKey: PortfolioKeys.insuranceRiskTypes(),
		queryFn: processResponse(() => getInsuranceRiskTypesV2()),
		staleTime: Number.POSITIVE_INFINITY,
	});
};
